import styled, {css} from 'styled-components';
import {device} from 'styled/device';

type NavigationStatusTextProps = {
  completed: boolean;
};

export const NavigationContainer = styled.div<{maxWidth?: string}>`
  padding: 16px;
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.07);

  @media (min-width: ${device.tablet}) {
    padding: 24px;
    margin: 0 auto 16px;
  }

  @media (min-width: ${device.laptop}) {
    max-width: ${props => props.maxWidth || '580px'};
  }
`;

export const NavigationItem = styled.div<{isClicked?: boolean}>`
  cursor: ${props => (props.isClicked ? 'pointer' : 'default')};
  display: flex;
  align-items: center;
  padding-bottom: 25px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const NavigationIcon = styled.img`
  margin-right: 16px;
`;

export const NavigationTexts = styled.div`
  display: block;
`;

export const NavigationTitle = styled.div`
  display: block;
  width: 100%;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #152946;
`;

export const NavigationStatusText = styled.div<NavigationStatusTextProps>`
  display: flex;
  align-items: center;
  width: 100%;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #ffb27d;
  ${props =>
    props.completed &&
    css`
      color: #32d7be;
    `}
`;

export const NextArrow = styled.img.attrs({className: 'nav-item__next-arrow'})`
  margin-left: auto;
`;

export const NavigationStatusIcon = styled.img`
  margin-right: 5px;
`;

export const PaymentAndOrdersPanel = styled.div<{isLoading: boolean}>`
  display: flex;
  width: 100%;
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.07);
  border-radius: 6px;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  cursor: pointer;
  transition: 0.3s opacity;

  @media (min-width: ${device.tablet}) {
    margin: 16px auto 0;
    width: 100%;
  }

  @media (min-width: ${device.laptop}) {
    max-width: 580px;
  }

  ${props =>
    props.isLoading &&
    css`
      opacity: 0.6;
    `}
`;

export const PaymentAndOrdersTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-left: 10px;
  letter-spacing: -0.15px;
  color: #152946;
  width: 70%;
`;

export const PaymentAndOrdersActions = styled.div`
  display: flex;
  margin-left: auto;
`;

export const PaymentAndOrdersNumber = styled.div<{$blueMode: boolean}>`
  width: 25px;
  height: 22px;
  background: ${props =>
    props.$blueMode
      ? '#385BF8'
      : 'radial-gradient(50% 50% at 50% 50%, #bec2d6 0%, #a8adc7 100%)'};
  border-radius: 11px;
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 13px;
  font-size: 14px;
  font-weight: 700;
`;

export const NavigationDescription = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  max-width: 199px;

  @media (min-width: ${device.tablet}) {
    max-width: 100%;
  }
`;
